(function(){
  var root = document.documentElement;
  var sun = '<path d="M12 4V2M12 22v-2M4 12H2M22 12h-2M6 6 4.6 4.6M19.4 19.4 18 18M18 6l1.4-1.4M4.6 19.4 6 18"/><circle cx="12" cy="12" r="4.2"/>';
  var moon = '<path d="M21 12.8A8.5 8.5 0 1 1 11.2 3a6.6 6.6 0 0 0 9.8 9.8Z"/>';

  /* ---------------- DAY / NIGHT ---------------- */
  function setMode(mode, remember){
    root.setAttribute('data-mode', mode);
    document.querySelectorAll('[data-knob-icon]').forEach(function(i){ i.innerHTML = mode==='day'?sun:moon; });
    document.querySelectorAll('[data-copy]').forEach(function(el){
      var v = el.getAttribute(mode==='day' ? 'data-copy-day' : 'data-copy-night');
      if (v !== null && v !== undefined && v !== '') el.innerHTML = v;
    });
    if (remember){ try{ localStorage.setItem('orphic-mode', mode); }catch(e){} }
  }
  var saved=null; try{ saved=localStorage.getItem('orphic-mode'); }catch(e){}
  setMode(saved === 'day' ? 'day' : 'night', false);
  document.querySelectorAll('[data-mode-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){ setMode(root.getAttribute('data-mode')==='day'?'night':'day', true); });
  });

  /* ---------------- REVEAL + STICKY ---------------- */
  var atc = document.querySelector('[data-sticky-atc]');
  var hero = document.querySelector('[data-hero]');
  if (atc && hero && 'IntersectionObserver' in window){
    new IntersectionObserver(function(e){ atc.classList.toggle('show', !e[0].isIntersecting); }, {threshold:0.1}).observe(hero);
  } else if (atc && !hero){ atc.classList.add('show'); }

  var rev = null;
  if ('IntersectionObserver' in window){
    rev = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); rev.unobserve(en.target); } });
    }, {threshold:0.14, rootMargin:'0px 0px -8% 0px'});
  }
  function armReveals(root){
    (root || document).querySelectorAll('.reveal').forEach(function(el){
      if (el.classList.contains('in')) return;
      if (rev){
        // only hide elements the observer is actually watching
        el.classList.add('armed');
        rev.observe(el);
      } else {
        el.classList.add('in');
      }
    });
  }
  armReveals(document);
  // Shopify theme editor re-renders sections with fresh DOM — re-arm and show them
  document.addEventListener('shopify:section:load', function(e){
    if (e.target){ e.target.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }
  });
  document.addEventListener('shopify:section:select', function(e){
    if (e.target){ e.target.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }
  });

  /* ---------------- PRODUCT RECOMMENDATIONS ---------------- */
  document.querySelectorAll('[data-recs][data-rec-url]').forEach(function(el){
    var url = el.getAttribute('data-rec-url');
    if(!url) return;
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html,'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.querySelector('.product-card')){
        el.innerHTML = fresh.innerHTML;
        el.querySelectorAll('.reveal').forEach(function(n){ n.classList.add('in'); });
      }
    }).catch(function(){});
  });

  /* ---------------- SLIDE-IN MENU ---------------- */
  var menuPanel = document.querySelector('[data-menu-panel]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');
  var menuLastFocus = null;
  function openMenu(){
    if(!menuPanel) return;
    menuLastFocus = document.activeElement;
    menuOverlay.hidden = false;
    requestAnimationFrame(function(){ menuOverlay.classList.add('show'); menuPanel.classList.add('open'); });
    menuPanel.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var c = menuPanel.querySelector('[data-menu-close]'); if(c) c.focus();
  }
  function closeMenu(){
    if(!menuPanel) return;
    menuPanel.classList.remove('open'); menuOverlay.classList.remove('show');
    menuPanel.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    setTimeout(function(){ menuOverlay.hidden = true; }, 450);
    if (menuLastFocus) menuLastFocus.focus();
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-menu-open]')){ e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-overlay]')){ e.preventDefault(); closeMenu(); return; }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && menuPanel && menuPanel.classList.contains('open')) closeMenu(); });

  /* ---------------- CART DRAWER ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var lastFocus = null;

  function openDrawer(){
    if(!drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function(){ overlay.classList.add('show'); drawer.classList.add('open'); });
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('open'); overlay.classList.remove('show');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    setTimeout(function(){ overlay.hidden = true; }, 450);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn){ e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-overlay]') || e.target.closest('[data-drawer-close-link]')){
      e.preventDefault(); closeDrawer(); return;
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && drawer && drawer.classList.contains('open')) closeDrawer(); });

  function setCounts(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent='['+n+']'; });
    var dc = document.querySelector('[data-drawer-count]'); if (dc) dc.textContent='('+n+')';
  }

  /* Re-render drawer body + footer from a fresh cart using the Section Rendering API */
  function refreshDrawer(openAfter){
    if(!drawer) { return; }
    // preserve unsaved gift-note text + open state across re-render
    var prevNote = null, prevOpen = false;
    var existingInput = drawer.querySelector('[data-gift-input]');
    if (existingInput) prevNote = existingInput.value;
    var existingBody = drawer.querySelector('[data-gift-body]');
    if (existingBody) prevOpen = !existingBody.hidden;

    drawer.classList.add('loading');
    fetch('/cart?section_id=cart-drawer-fragment', {headers:{'Accept':'text/html'}})
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-drawer-body]');
        var oldBody = drawer.querySelector('[data-drawer-body]');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
        var newFoot = doc.querySelector('[data-drawer-foot]');
        var oldFoot = drawer.querySelector('[data-drawer-foot]');
        if (newFoot && oldFoot){ oldFoot.innerHTML = newFoot.innerHTML; oldFoot.hidden = newFoot.hidden; }
        // restore gift note
        if (prevNote !== null){
          var ni = drawer.querySelector('[data-gift-input]');
          if (ni && !ni.value) ni.value = prevNote;
        }
        if (prevOpen){
          var nb = drawer.querySelector('[data-gift-body]');
          var tg = drawer.querySelector('[data-gift-toggle]');
          if (nb){ nb.hidden = false; if (tg){ tg.setAttribute('aria-expanded','true'); var c=tg.querySelector('.gift-note-chev'); if(c) c.textContent='\u2212'; } }
        }
        drawer.classList.remove('loading');
        if (openAfter) openDrawer();
      })
      .catch(function(){
        drawer.classList.remove('loading');
        if (openAfter) openDrawer();
      });
  }

  function syncCart(openAfter){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCounts(c.item_count); refreshDrawer(openAfter); })
      .catch(function(){ if(openAfter) openDrawer(); });
  }
  // initial count
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ setCounts(c.item_count); }).catch(function(){});

  /* ---------------- ADD TO CART (buttons with data-atc / data-variant-id) ---------------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-atc]');
    if(!btn) return;
    var id = btn.getAttribute('data-variant-id');
    if(!id) return;
    e.preventDefault();

    // Upsell cards inside the drawer: keep layout, just flash the + button
    var isUpsell = btn.classList.contains('upsell-card');
    if (isUpsell){
      var addEl = btn.querySelector('.upsell-add');
      btn.setAttribute('disabled','');
      if (addEl) addEl.innerHTML = '&#10003;';
      fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
        .then(function(r){ return r.json(); })
        .then(function(){ syncCart(false); })   // drawer already open; refresh recomputes upsell
        .catch(function(){ btn.removeAttribute('disabled'); if(addEl) addEl.innerHTML='+'; });
      return;
    }

    var orig = btn.innerHTML;
    btn.setAttribute('disabled','');
    fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
      .then(function(r){ return r.json(); })
      .then(function(){ btn.innerHTML='Added \u2726'; syncCart(true);
        setTimeout(function(){ btn.innerHTML=orig; btn.removeAttribute('disabled'); },1400); })
      .catch(function(){ btn.innerHTML='Try again'; setTimeout(function(){ btn.innerHTML=orig; btn.removeAttribute('disabled'); },1400); });
  });

  /* ---------------- PDP FORM: variant select + AJAX add ---------------- */
  document.querySelectorAll('[data-product-root]').forEach(function(rootEl){
    var jsonEl = rootEl.querySelector('[data-variant-json]');
    if(!jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch(e){ variants = []; }
    var idInput = rootEl.querySelector('[data-variant-id]');
    var priceEl = rootEl.querySelector('[data-price]');
    var compareEl = rootEl.querySelector('[data-compare]');
    var atcBtn = rootEl.querySelector('[data-atc-form]');
    var atcText = rootEl.querySelector('[data-atc-text]');
    var mainImg = rootEl.querySelector('[data-main-img]');
    var selected = {};

    // seed selected from active swatches/pills
    rootEl.querySelectorAll('[data-swatch].is-active').forEach(function(el){
      selected[el.getAttribute('data-option-position')] = el.getAttribute('data-value');
    });

    function money(cents){
      return '$' + (cents/100).toFixed(2).replace(/\.00$/,'');
    }
    function findVariant(){
      return variants.find(function(v){
        return ['option1','option2','option3'].every(function(opt,i){
          var pos = String(i+1);
          if (selected[pos] === undefined) return true;
          return v[opt] === selected[pos];
        });
      });
    }
    function update(){
      var v = findVariant();
      if(!v){ if(atcBtn){atcBtn.setAttribute('disabled','');} if(atcText)atcText.textContent='Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl){ if(v.compare_at_price>v.price){compareEl.textContent=money(v.compare_at_price);compareEl.style.display='';}else{compareEl.style.display='none';} }
      if (v.featured_image && mainImg){ mainImg.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'_1000x$1$2'); }
      if (atcBtn && atcText){
        if (v.available){ atcBtn.removeAttribute('disabled'); atcText.textContent='Add to bag \u2014 '+money(v.price); }
        else { atcBtn.setAttribute('disabled',''); atcText.textContent='Sold out'; }
      }
    }

    rootEl.querySelectorAll('[data-swatch]').forEach(function(sw){
      sw.addEventListener('click', function(){
        var pos = sw.getAttribute('data-option-position');
        selected[pos] = sw.getAttribute('data-value');
        var group = sw.parentElement;
        group.querySelectorAll('[data-swatch]').forEach(function(s){ s.classList.remove('is-active'); s.setAttribute('aria-checked','false'); });
        sw.classList.add('is-active'); sw.setAttribute('aria-checked','true');
        var lbl = rootEl.querySelector('[data-opt-selected="'+pos+'"]');
        if (lbl) lbl.textContent = sw.getAttribute('data-value');
        update();
      });
    });

    var form = rootEl.querySelector('form[action*="/cart/add"], form[action="/cart/add"]') || rootEl.querySelector('form');
    if (form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var id = idInput ? idInput.value : null;
        if(!id) return;
        var orig = atcText ? atcText.textContent : '';
        if (atcBtn) atcBtn.setAttribute('disabled','');
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){ return r.json(); })
          .then(function(){ if(atcText)atcText.textContent='Added \u2726'; syncCart(true);
            setTimeout(function(){ if(atcText)atcText.textContent=orig; if(atcBtn)atcBtn.removeAttribute('disabled'); },1400); })
          .catch(function(){ if(atcText)atcText.textContent='Try again'; setTimeout(function(){ if(atcText)atcText.textContent=orig; if(atcBtn)atcBtn.removeAttribute('disabled'); },1400); });
      });
    }

    // seamless swipe gallery + dots
    var slidesWrap = rootEl.querySelector('[data-pdp-slides]');
    if (slidesWrap){
      var slides = slidesWrap.querySelectorAll('[data-pdp-slide]');
      var dots = rootEl.querySelectorAll('[data-pdp-dot]');
      function setActiveDot(i){ dots.forEach(function(d,di){ d.classList.toggle('is-active', di===i); }); }
      dots.forEach(function(dot){
        dot.addEventListener('click', function(){
          var i = parseInt(dot.getAttribute('data-index'),10);
          if (slides[i]) slidesWrap.scrollTo({left: slides[i].offsetLeft - slidesWrap.offsetLeft, behavior:'smooth'});
          setActiveDot(i);
        });
      });
      var graf;
      slidesWrap.addEventListener('scroll', function(){
        cancelAnimationFrame(graf);
        graf = requestAnimationFrame(function(){
          var nearest=0, min=Infinity;
          slides.forEach(function(s,i){ var d=Math.abs(s.offsetLeft - slidesWrap.offsetLeft - slidesWrap.scrollLeft); if(d<min){min=d;nearest=i;} });
          setActiveDot(nearest);
        });
      });
    }

    update();
  });

  /* ---------------- GIFT NOTE ---------------- */
  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-gift-toggle]');
    if (toggle){
      var body = toggle.parentElement.querySelector('[data-gift-body]');
      var chev = toggle.querySelector('.gift-note-chev');
      if (body){
        var isOpen = !body.hidden;
        body.hidden = isOpen;
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (chev) chev.textContent = isOpen ? '+' : '\u2212';
        if (!isOpen){ var ta = body.querySelector('[data-gift-input]'); if (ta) ta.focus(); }
      }
      return;
    }
    var save = e.target.closest('[data-gift-save]');
    if (save){
      var wrap = save.closest('.gift-note');
      var input = wrap.querySelector('[data-gift-input]');
      var status = wrap.querySelector('[data-gift-status]');
      var note = input ? input.value : '';
      save.setAttribute('disabled','');
      if (status) status.textContent = 'Saving\u2026';
      fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note:note})})
        .then(function(r){ return r.json(); })
        .then(function(){ if(status) status.textContent = 'Saved \u2726'; save.removeAttribute('disabled');
          setTimeout(function(){ if(status) status.textContent=''; }, 2200); })
        .catch(function(){ if(status) status.textContent = 'Try again'; save.removeAttribute('disabled'); });
      return;
    }
  });

  /* ---------------- REVIEWS CAROUSEL ---------------- */
  document.querySelectorAll('[data-reviews]').forEach(function(root){
    var track = root.querySelector('[data-reviews-track]');
    if(!track) return;
    var slides = root.querySelectorAll('[data-review-slide]');
    var current = root.querySelector('[data-review-current]');
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    var idx = 0;
    function pad(n){ return (n<10?'0':'')+n; }
    function go(i){
      idx = Math.max(0, Math.min(slides.length-1, i));
      if (slides[idx]) track.scrollTo({left: slides[idx].offsetLeft - track.offsetLeft, behavior:'smooth'});
      if (current) current.textContent = pad(idx+1);
    }
    if (prev) prev.addEventListener('click', function(){ go(idx-1); });
    if (next) next.addEventListener('click', function(){ go(idx+1); });
    // update counter on manual swipe
    var raf;
    track.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var nearest = 0, min = Infinity;
        slides.forEach(function(s,i){
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min){ min = d; nearest = i; }
        });
        idx = nearest;
        if (current) current.textContent = pad(idx+1);
      });
    });
  });

  /* ---------------- DRAWER QTY + REMOVE (event-delegated) ---------------- */
  function changeLine(key, qty){
    if(!drawer) return;
    drawer.classList.add('loading');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCounts(c.item_count); refreshDrawer(false); })
      .catch(function(){ drawer.classList.remove('loading'); });
  }
  document.addEventListener('click', function(e){
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var rem = e.target.closest('[data-remove]');
    if (up || down){
      var li = e.target.closest('[data-line-item]');
      var key = (up||down).getAttribute('data-line-key');
      var val = parseInt(li.querySelector('[data-qty-val]').textContent,10) || 1;
      changeLine(key, up ? val+1 : Math.max(0, val-1));
    } else if (rem){
      changeLine(rem.getAttribute('data-line-key'), 0);
    }
  });
})();
